import { Autocomplete } from '@src/types/Autocomplete'
import React, { useRef } from 'react'
import { apiSprayBinderTypeDepotSearch } from '../../apis/spray-binder-type-depot-search'
import AutocompleteComp from '../GeneralAutocomplete/Autocomplete'

function SprayDepotAutocomplete({
  id = '',
  label = '',
  onChange,
  selectedItem,
  fullWidth = false,
  disabled = false,
}: Autocomplete) {
  // Cache the depot data to avoid repeated API calls
  const depotDataCache = useRef<any[]>(null)
  const fetch = async (query: string) => {
    // Load data from cache or API
    if (!depotDataCache.current) {
      const result: any = await apiSprayBinderTypeDepotSearch({ query: '' }) // Get all data
      depotDataCache.current = result.data.spraybindertypedepots
    }
    
    // Filter locally based on user input
    const filteredDepots = depotDataCache.current
      .filter((depot: any) => {
        if (!query) return true // Show all if no query
        
        // Search in depot name and spray depot ID (case insensitive)
        const searchText = query.toLowerCase()
        const depotName = depot.depotName.toLowerCase()
        const sprayDepotId = depot.sprayDepotId.toLowerCase()
        
        return depotName.includes(searchText) || sprayDepotId.includes(searchText)
      })
      .slice(0, 10)
      .map((depot: any) => {
        return {
          value: depot.id,
          label: `${depot.depotName} (${depot.sprayDepotId})`,
          raw: depot,
        }
      })
    
    return filteredDepots
  }
  let finalSelectedItem 
  if (selectedItem && selectedItem.value) {
    finalSelectedItem = selectedItem
  } else {
    finalSelectedItem = { value: '', label: '' }
  }
  return <AutocompleteComp
    id={id}
    label={label || 'Spray Depot'}
    fetch={fetch}
    selectedItem={finalSelectedItem}
    onChange={onChange}
    dropdownAutoWidth={true}
    fullWidth={fullWidth}
    disabled={disabled}
  />
}

export default SprayDepotAutocomplete